import { useContext } from "react";

import { NodeTransientStateContext } from "./NodeTransientStateContext.ts";

export type NodeStateHook<T, I = never> = [value: T | I, setValue: (newValue: T) => void];
export const useNodeState = <T, I = T>(id: number, initialValue: I | (() => I)): NodeStateHook<T, I> => {
  const context = useContext(NodeTransientStateContext);
  return context.useTransientState(id, initialValue);
};
